import BaseComponent from '../BaseComponent'
import DoPage from '../pages/Do'
import React from 'react'
import _ from 'lodash'
import { bindFunctions } from '../lib/componentUtils'
import database from 'firebase/database'
import leftPad from 'left-pad'
import rightPad from 'right-pad'
import { smush } from '../lib/firebaseUtils'
import { withRouter } from 'react-router'

class DoContainer extends BaseComponent {
	constructor(props) {
		super()
		this.state = {
			loading: true,
			exercise: null,
			logs: null,
			metrics: {},
			selectedTags: [],
			exampleVideos: [],
			myTags: [],
			savingLog: false
		}

		this.exerciseId = props.match.params.exerciseId

		this.loadingNames = ['exercise', 'logs', 'exampleVideos']

		bindFunctions(
			[
				'doneLoading',
				'setMetric',
				'removeMetric',
				'addMetric',
				'saveLog',
				'addTagAsSelected',
				'setSelectedTags',
				'removeLog',
				'setRecordedVideoBlobs',
				'uploadVideo'
			],
			this
		)
	}

	// Returns a promise to upload video to cloudinary
	// * If no video to upload, promise resolves to null
	// * After a upload promise resolves to cloudinary public_id
	uploadVideo() {
		return new Promise((resolve, reject) => {
			if (!this.state.recordedVideoBlobs) {
				resolve(null)
			}
			const cloudName = 'zinid'
			const cloudinaryurl = `https://api.cloudinary.com/v1_1/${cloudName}/video/upload`
			const formData = new FormData()
			const blob = new Blob(this.state.recordedVideoBlobs, { type: 'video/webm' })
			formData.append('upload_preset', 'exercisevideos')
			formData.append('file', blob, 'video.webm')

			fetch(cloudinaryurl, {
				method: 'post',
				body: formData
			})
				.then(res => res.json())
				.then(data => resolve(data.public_id))
		})
	}

	removeLog(logId) {
		database().ref(`logs/${logId}`).remove()
	}

	saveLog() {
		const when = String(new Date().getTime())
		return new Promise((resolve, reject) => {
			this.setState({ savingLog: true })
				.then(this.uploadVideo)
				.then(cloudinaryVideoPublicId => {
					const log = {
						user: this.props.uid,
						exercise: this.exerciseId,
						metrics: _.omitBy(this.state.metrics, n => !_.isNumber(n)),
						when,
						tags: this.state.selectedTags,
						userExercise: `${this.props.uid}${this.exerciseId}`,
						userWhen: `${rightPad(this.props.uid, 100, '.')}${leftPad(when, 15, '0')}`,
						cloudinaryVideoPublicId,
						userExerciseWhen: `${rightPad(
							this.props.uid + this.exerciseId,
							140,
							'.'
						)}${leftPad(when, 15, '0')}`
					}
					return new Promise(res => database().ref('logs').push(log, res))
				})
				.then(() => this.setState({ savingLog: false }))
				.then(resolve)
		})
	}

	setRecordedVideoBlobs(recordedVideoBlobs) {
		this.setState({ recordedVideoBlobs })
	}

	setMetric(metric, val) {
		const metrics = _.clone(this.state.metrics)
		metrics[metric] = Number(val)
		this.setState({ metrics })
	}

	removeMetric(metric) {
		const metrics = _.clone(this.state.metrics)
		delete metrics[metric]
		this.setState({ metrics })
	}

	addMetric(metric) {
		const metrics = _.clone(this.state.metrics)
		metrics[metric] = ''
		this.setState({ metrics })
	}

	addTagAsSelected(tag) {
		this.setState(prevState => ({
			selectedTags: _.union(prevState.selectedTags, [tag])
		}))
	}

	setSelectedTags(selectedTags) {
		this.setState(prevState => ({ selectedTags }))
	}

	doneLoading(name) {
		this.loadingNames = _.pull(this.loadingNames, name)
		if (0 === this.loadingNames.length) {
			this.setState({ loading: false })
		}
	}

	componentDidMount() {
		// Load exercise data in realtime
		this.exerciseRef = database().ref(`exercises/${this.exerciseId}`)
		this.exerciseRef.on('value', exercise => {
			this.setState({ exercise: exercise.val() }).then(() => this.doneLoading('exercise'))
		})

		// Load logs in realtime
		const userExercise = `${this.props.uid}${this.exerciseId}`
		this.logsRef = database()
			.ref('logs')
			.orderByChild('userExercise')
			.equalTo(userExercise)
		this.logsRef.on('value', logsSnap => {
			const logs = _.sortBy(smush(logsSnap), 'when').reverse()
			const metricKeys = _.uniq(_.flatMap(logs, log => _.keys(log.metrics)))
			const metrics = _.zipObject(metricKeys, _.map(metricKeys, _.constant('')))
			// eslint-disable-next-line no-undefined
			const myTags = _.uniq(_.without(_.flatMap(logs, 'tags'), undefined))
			const selectedTags = []
			this.setState({ logs, metrics, myTags, selectedTags }).then(() =>
				this.doneLoading('logs')
			)
		})

		// Load examples (logs with videos) one time
		const paddedExerciseId = rightPad(this.exerciseId, 40, '.')
		const start = `${paddedExerciseId}${_.repeat('0', 20)}`
		const end = `${paddedExerciseId}${_.repeat('9', 20)}`
		database()
			.ref('logs')
			.orderByChild('exerciseVideoValue')
			.startAt(start)
			.endAt(end)
			.limitToLast(20)
			.once('value')
			.then(logsSnap => {
				const exampleVideos = _.map(logsSnap.val(), 'cloudinaryVideoPublicId')
				return this.setState({
					exampleVideos
				})
			})
			.then(() => this.doneLoading('exampleVideos'))
	}

	componentWillUnmount() {
		if (this.exerciseRef) {
			this.exerciseRef.off()
		}
		if (this.logsRef) {
			this.logsRef.off()
		}
	}

	render() {
		const methods = {
			setMetric: this.setMetric,
			removeMetric: this.removeMetric,
			addMetric: this.addMetric,
			saveLog: this.saveLog,
			removeLog: this.removeLog,

			addTagAsSelected: this.addTagAsSelected,
			setSelectedTags: this.setSelectedTags,

			setRecordedVideoBlobs: this.setRecordedVideoBlobs,
			setTab: this.props.setTab
		}
		return <DoPage tab={this.props.tab} {...this.state} {...methods} />
	}
}
export default withRouter(DoContainer)



// WEBPACK FOOTER //
// ./src/containers/DoContainer.js